module.exports = __webpack_public_path__ + "static/media/ch.6539c600.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ch.svg
// module id = 84
// module chunks = 0